import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M5.79508 11.3749L1.62508 7.20492L0.205078 8.61492L5.79508 14.2049L17.7951 2.20492L16.3851 0.794922L5.79508 11.3749Z",
  fill: "currentColor"
})), 'CheckThin', {
  viewBox: '0 0 18 15'
});